import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import { Map } from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Map({})
	.set('Get', new Map({}))
	.set('Response', new Map({}))

/* Types */
export const GET_REQUIREMENT_DOCS = 'GET_REQUIREMENT_DOCS'
export const BANK_ACCOUNT_INFO = 'BANK_ACCOUNT_INFO'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case GET_REQUIREMENT_DOCS:
			return state.set('Get', new Map(action.Obj))
		case BANK_ACCOUNT_INFO:
			return state.set('Response', new Map(action.Obj))
		default:
			return state;
	}
};

/* Action Creators */

export const getRequirementDocuments = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getRequirementDocuments',
			method: "POST",
			data: { ...form },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false));
			dispatch({ type: GET_REQUIREMENT_DOCS, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const saveBankInfo = (form) => {

	let temp = {
		banco: form.banco,
		clabe: form.clabe,
		createdBy: sessionStorage.uid,
		deleted: false,
		id: form.idDonatariaDatoPago || 0,
		idCorrida: form.idCorrida,
		idDonataria: form.idDonataria,
		numeroRecibo: form.recibo,
		montoSolicitado: parseFloat(form.montoEntregar),
		referencia1: form.referencia1 || "",
		referencia2: form.referencia2 || "",
		referencia3: form.referencia3 || "",
	}

	if (form.idDonatariaRecibo) {
		temp.idDonatariaRecibo = form.idDonatariaRecibo
	}

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: form.idDonatariaRecibo ? 'api/updateBankInfo' : 'api/saveBankInfo',
			method: "POST",
			data: { ...temp },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false));
			dispatch({ type: BANK_ACCOUNT_INFO, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const deleteBankInfo = (form) => {

	let temp = {
		banco: form.banco,
		clabe: form.clabeInterbancaria,
		createdBy: sessionStorage.uid,
		deleted: true,
		id: form.idDonatariaDatoPago,
		idDonatariaRecibo: form.idDonatariaRecibo,
		idCorrida: form.idCorrida,
		idDonataria: form.idDonataria,
		numeroRecibo: form.numeroRecibo,
		montoSolicitado: parseFloat(form.montoSolicitado),
		referencia1: form.referencia1 || "",
		referencia2: form.referencia2 || "",
		referencia3: form.referencia3 || "",
	}

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/updateBankInfo',
			method: "POST",
			data: { ...temp },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false));
			return response.data
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const saveRequirements = (form) => {

	let documentos = form.form.documentosRequeridos.filter(d => d.fase.id === "requisitos-documentos").map((d) => {
		return {
			deleted: false,
			entregado: d.entregoId || null,
			idDonatariaDocumento: d.idDonatariaDocumento,
			revisado: d.revisado || false
		}
	})

	let documentosRequsitosPago = form.form.documentosRequeridos.filter(d => d.fase.id === "requisitos-pago").map((d) => {
		return {
			deleted: false,
			entregado: d.entregoId || null,
			idDonatariaRequisitoPago: d.idDonatariaRequisitoPago,
			revisado: d.revisado || false
		}
	})

	let informacionBancaria = form.form.informacionBancaria.map((i) => {

		return {
			deleted: false,
			idDonatariaRecibo: i.idDonatariaRecibo,
			revisado: i.revisado || false
		}
	})

	let temp = {
		usuario: sessionStorage.uid,
		documentos,
		documentosRequsitosPago,
		idCorrida: form.idCorrida,
		idDonataria: form.idDonataria,
		informacionBancaria,
		tipoPago: { id: form.form.validatePay || null }
	}

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/saveRequirements',
			method: "POST",
			data: { ...temp },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false));
			return response.data
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const clearRequirements = () => {
	return (dispatch) => {
		dispatch({ type: GET_REQUIREMENT_DOCS, Obj: {} })
	}
}



// WEBPACK FOOTER //
// ./src/modules/MissingInfo/Requirements/index.js